"use strict";

angular.module('app.models.accessRequest', []).

factory('_AccessRequest',
    ['$resource','appConfig',
        function($resource,appConfig)
    {
        var destinationId = appConfig().destinationId;
        var res = $resource(appConfig().api_host+'Portal/'+destinationId, null , {
            'GetAccessPrincipals': {
              method: 'GET',
              url : appConfig().api_host+'Portal/GetAccessPrincipals/'+destinationId
            },
            'SetAccessPrincipal': {
              method: 'POST',
              url : appConfig().api_host+'Portal/SetAccessPrincipal/'+destinationId
            }
          });

        var obj = {};
        obj.get = function( a ){
                return res.get(null,{'AccessRequest':a});
            };
        obj.GetAccessPrincipals = function(){
                return res.GetAccessPrincipals();
            };
        obj.SetAccessPrincipal = function( a ){
                return res.SetAccessPrincipal( null, a );
            };
        obj.delete = function( a,b,c ){
                return res.delete( a,b,c );
            };


        return obj;




  }]);
